import type { FunctionComponent, ReactNode } from 'react';
import { Fragment, isValidElement } from 'react';

import { DynamicValueReplacer } from '../DynamicValueReplacer';
import type { RenderableDynamicValue, RenderableDynamicValues } from '../types';

export interface DynamicValueTextProps {
  children: string;
  dynamicValues: RenderableDynamicValues;
}

export const DynamicValueNode: FunctionComponent<DynamicValueTextProps> = ({ children, dynamicValues }) => {
  const valueSplitByDynamicValues = DynamicValueReplacer.splitAndCapture(children);

  return valueSplitByDynamicValues.map((part, index) => {
    let returnValue: ReactNode;
    if (typeof part === 'string') {
      returnValue = part;
    } else {
      const { key, match } = part;
      if (typeof dynamicValues === 'function') {
        return dynamicValues(key, match);
      }
      const dynamicValue = dynamicValues?.[key as never] as RenderableDynamicValue;
      if (dynamicValue) {
        if (isValidElement(dynamicValue)) {
          returnValue = dynamicValue;
        } else if (typeof dynamicValue === 'function') {
          returnValue = dynamicValue(key, match);
        } else {
          returnValue = String(dynamicValue);
        }
      } else {
        returnValue = match;
      }
    }
    return <Fragment key={index}>{returnValue}</Fragment>;
  });
};
